import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";

const serviceProgressSteps = {
  Delivery: [
    {stepName: 'Created', stepNumber: 1},
    {stepName: 'Routed', stepNumber: 2},
    {stepName: 'Assigned', stepNumber: 3},
    {stepName: 'Heading pickup', stepNumber: 4},
    {stepName: 'Arrived pickup', stepNumber: 5},
    {stepName: 'Departed pickup', stepNumber: 6},
    {stepName: 'Heading dropoff', stepNumber: 7},
    {stepName: 'Arrived dropoff', stepNumber: 8},
    {stepName: 'Departed dropoff', stepNumber: 9}
  ],
  Operation: [
    {stepName: 'Created', stepNumber: 1},
    {stepName: 'Routed', stepNumber: 2},
    {stepName: 'Assigned', stepNumber: 3},
    {stepName: 'Heading location', stepNumber: 4},
    {stepName: 'Arrived location', stepNumber: 5},
    {stepName: 'Departed location', stepNumber: 6}
  ]
};

require('./service-progress-tooltip.scss');
@Component({
  standalone: false,
  selector: 'app-service-progress-tooltip',
  templateUrl: './service-progress-tooltip.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceProgressTooltipComponent implements OnInit{

  @Input() progress: any;
  @Input() serviceType: any;

  public progressSteps: any;

  constructor() {
  }

  ngOnInit() {
    this.progressSteps = serviceProgressSteps[this.serviceType];
  }

}
